import { ISchemaInput, ISIBare, ISIConst, NestedSchema, RootSchema, TD } from '../union';
import { ISchemaBoolean } from './boolean.types';
import { IsNever, SchemaTypeName } from './core';

export * from './boolean.types';

/**
 * Property value is a boolean or array of booleans
 * - No enum
 * - Never nullable
 */
export function boolean(
    schema: RootSchema<ISchemaInput<ISchemaBoolean, ISIBare<ISchemaBoolean>>>
): RootSchema<ISchemaBoolean>;
export function boolean<ConstVal extends TD<ISchemaBoolean>>(
    schema: NestedSchema<ISchemaInput<ISchemaBoolean, ISIConst<ISchemaBoolean, TD<ISchemaBoolean>>>>
): NestedSchema<ISchemaBoolean<ConstVal>>;
export function boolean(
    schema: ISchemaInput<ISchemaBoolean, ISIBare<ISchemaBoolean>>
): ISchemaBoolean;
export function boolean(schema: ISchemaInput<ISchemaBoolean>): ISchemaBoolean {
    return {
        type: SchemaTypeName.boolean,
        ...schema,
    };
}

/**
 * Validation
 */

//  Confirm that the type of `b1` is `string`
const b1 = boolean({ description: '', $id: 'hello', title: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B1 = IsNever<Exclude<typeof b1, string>>;

//  Confirm that the type of `b2` is `string | undefined`
const b2 = boolean({ description: '' }).$id;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type B2 = IsNever<Exclude<typeof b2, string | undefined>>;
